import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { RequestDeviceProtectiveCaseFormFields } from './types';

export const protectiveCaseNumberRequiredValidationError =
  'protectiveCaseNumberRequired';

export const protectiveCaseNumberCrossFieldsValidator: ValidatorFn = (
  formControl: AbstractControl,
): ValidationErrors | null => {
  const formGroup = formControl as FormGroup;
  const hasProtectiveCaseField =
    formGroup.controls[RequestDeviceProtectiveCaseFormFields.HasProtectiveCase];
  const protectiveCaseNumberField =
    formGroup.controls[
      RequestDeviceProtectiveCaseFormFields.ProtectiveCaseNumber
    ];

  if (hasProtectiveCaseField.value && !protectiveCaseNumberField.value) {
    protectiveCaseNumberField.setErrors({
      [protectiveCaseNumberRequiredValidationError]: true,
    });
  } else {
    if (
      protectiveCaseNumberField.errors &&
      protectiveCaseNumberRequiredValidationError in
        protectiveCaseNumberField.errors
    ) {
      delete protectiveCaseNumberField.errors[
        protectiveCaseNumberRequiredValidationError
      ];
    }
  }

  return null;
};
